var _text, _text2, _text3, _text4, _rect, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add counter function block") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    font: "18px sans-serif",
    fontWeight: "bold",
    x: 24,
    y: 42,
    dominantBaseline: "middle",
    textAnchor: "middle",
    opacity: 0.8
  }, "\r\n        0\r\n    ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    font: "18px sans-serif",
    fontWeight: "bold",
    x: 40,
    y: 42,
    dominantBaseline: "middle",
    textAnchor: "middle",
    opacity: 0.8
  }, "\r\n        0\r\n    ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    font: "18px sans-serif",
    fontWeight: "bold",
    x: 56,
    y: 34,
    dominantBaseline: "middle",
    textAnchor: "middle",
    opacity: 0.8
  }, "\r\n        6\r\n    ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    font: "18px sans-serif",
    fontWeight: "bold",
    x: 56,
    y: 50,
    dominantBaseline: "middle",
    textAnchor: "middle",
    opacity: 0.8
  }, "\r\n        7\r\n    ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 52,
    height: 32,
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    x2: 32,
    y1: 24,
    y2: 56,
    opacity: 0.8,
    stroke: "#000",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48,
    x2: 48,
    y1: 24,
    y2: 56,
    opacity: 0.8,
    stroke: "#000",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 40,
    x2: 14,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 40,
    x2: 80,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter);
export default __webpack_public_path__ + "static/media/counter.5f11b0a63e4dd9d0bb3a9def01ec05cd.svg";
export { ForwardRef as ReactComponent };